exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3 {\n  font-family: \"browallia\", FontAwesome;\n  color: red; }\n\n.scale-out-for-print {\n  zoom: 0.7; }\n\n@font-face {\n  font-family: 'Tahoma';\n  src: url(\"/assets/fonts/Tahoma Regular font.ttf\"); }\n\n.font-tahoma {\n  font-family: 'Tahoma';\n  font-size: 0.70rem; }\n\n.font-tahoma-fact-sheet {\n  font-family: 'Tahoma';\n  font-size: 1.1rem; }\n\n.remark-for-print {\n  color: gray; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/financial/financial.component.scss
// module id = ../../../../../src/app/securities-level/financial/financial.component.scss
// module chunks = main